import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import OTPInput from "./OTPInput";
import { changePassword, loginUser, verifyAccount } from "../../requests";
import {
  getFormattedEmail,
  notifyError,
  notifySuccess,
} from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, MoveLeft } from "lucide-react";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const Navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentPage === 1) {
      if (validate()) {
        await handleAccountLogin();
      }
    } else if (currentPage === 2) {
      await verifyOtp();
    } else if (currentPage === 3) {
      if (validatePassword()) {
        await handleChangePassword();
      }
    }
  };

  const handleAccountLogin = async () => {
    try {
      const response = await loginUser({
        email: email,
        newOtp: 1,
        forgot: 1,
      });
      if (response.status === 201) {
        setCurrentPage(2);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 401) {
        notifyError(error.response.data.message);
        // dispatch(setUser(null));
        // navigate("/login");
      } else if (error.response) {
        notifyError(error.response.data.message);
      } else {
        notifyError("Something went wrong");
      }
    }
  };

  const verifyOtp = async () => {
    try {
      const response = await verifyAccount({
        email: email,
        otp: otp.join(""),
        forgot: 1,
      });
      if (response.status === 200) {
        notifySuccess(response.data.message);
        setCurrentPage(3);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 401) {
        notifyError(error.response.data.message);
        // dispatch(setUser(null));
        // navigate("/login");
      } else if (error.response) {
        notifyError(error.response.data.message);
      } else {
        notifyError("Something went wrong");
      }
    }
  };

  const handleChangePassword = async () => {
    try {
      const response = await changePassword({
        email: email,
        password: password,
      });
      if (response.status === 200) {
        notifySuccess(response.data.message);
        setCurrentPage(1);
        Navigate("/login");
      }
    } catch (error) {
      if (error.response) {
        notifyError(error.response.data.message);
      } else {
        notifyError("Something went wrong");
      }
    }
  };

  const handleBackToLogin = (event) => {
    event.preventDefault();
    Navigate("/login");
  };

  const validate = () => {
    const newErrors = {};

    // Email validation
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email address.";
    }
    // else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}/.test(password)) {
    //   newErrors.password =
    //     "Password must be at least 8 characters long, contain a lowercase letter, an uppercase letter, and at least one special character.";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePassword = () => {
    let newErrors = {};
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}/.test(password)) {
      newErrors.password =
        "Password must be at least 8 characters long, contain a lowercase letter, an uppercase letter, and at least one special character.";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="login-container">
      <h6 className="mb-3">PractAIce</h6>
      <h4 className="font-clash-display fw-600">
        {currentPage === 1 && "Forgot Password"}
        {currentPage === 2 && "Enter Verification Code"}
        {currentPage === 3 && "Set new Password"}
      </h4>
      {currentPage === 1 && (
        <p className="text-muted mb-4 fs-13">
          Enter your email to reset your password.
        </p>
      )}
      {currentPage === 3 && (
        <p className="text-muted mb-4 fs-13">
          Must be altleast 8 characters long, contain a lowercase letter, an
          uppercase letter, and at least one special character.
        </p>
      )}
      {currentPage === 2 && (
        <>
          {/* <p className="text-muted mb-4 fs-13">
            Enter your email to reset your password.
          </p> */}
          <p style={{ marginTop: "-1rem" }} className="mb-4">
            Code sent to {getFormattedEmail(email)}
          </p>
        </>
      )}
      <Form onSubmit={handleSubmit}>
        {currentPage === 1 && (
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="john.dowry@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isInvalid={!!errors.email}
              style={{ backgroundColor: "white" }}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        {currentPage === 2 && <OTPInput otp={otp} setOtp={setOtp} />}
        {currentPage === 3 && (
          <>
            <Form.Group className="mb-2" controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  isInvalid={!!errors.password}
                />
                <Button
                  variant=""
                  onClick={() => setShowPassword(!showPassword)}
                  className="show-password-btn"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </Button>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            <Form.Group className="mb-2" controlId="confirmPassword">
              <Form.Label>Cofirm Password</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  isInvalid={!!errors.confirmPassword}
                />
                <Button
                  variant=""
                  onClick={() => setShowPassword(!showPassword)}
                  className="show-password-btn"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </Button>
                <Form.Control.Feedback type="invalid">
                  {errors.confirmPassword}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
          </>
        )}
        <Button
          variant="primary"
          type="submit"
          className="w-100 mt-4 login-submit-btn"
        >
          {currentPage === 3 ? "Reset Password" : "Continue"}
        </Button>
        <Button
          variant="light"
          onClick={handleBackToLogin}
          className="w-100 mt-3 fs-13"
        >
          <MoveLeft /> Back to login
        </Button>
      </Form>
    </div>
  );
};

export default ForgetPassword;
